import React, { useState } from 'react';
import { Box, Stack } from '@mui/material';

import 'react-image-crop/dist/ReactCrop.css';
import { IconWrapper } from 'components/Icon';
import { ImageUpload } from 'components/ImageUpload';
import { useParams } from 'react-router-dom';
import { useProfileImageUpload } from '../api/uploadImage';
import { useUsersById } from '../api/getUserById';

const baseStyles = {
  width: 100,
  innerHeight: 1,
  borderRadius: 1,
  // overflow: 'hidden',
};
const imageWrapperStyles = {
  bottom: 0,
  height: 100,
  position: 'absolute',
  cursor: 'pointer',

  ...baseStyles,
};

const placeholderStyles = {
  ...baseStyles,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const ProfileImage = ({ sx = {}, image }) => {
  const { id: userId } = useParams();
  const [open, setOpen] = useState(false);

  const { refetch } = useUsersById(userId);

  //    TODO - CHANGE THE square_logo PARAM
  const { mutate: uploadImage } = useProfileImageUpload(userId, 'square_logo', refetch);

  return (
    <>
      <ImageUpload
        title="Upload profile photo"
        uploadImage={uploadImage}
        image={image}
        open={open}
        handleClose={() => setOpen(false)}
      />

      <Box
        ml={4}
        width={100}
        onClick={() => setOpen(true)}
        sx={{
          position: 'relative',
          innerHeight: 1,
          borderRadius: 1,
          cursor: 'pointer',
        }}
      >
        <Stack
          position="absolute"
          width={1}
          bottom={24}
          height={100}
          justifyContent="center"
          alignItems="center"
          borderRadius={1}
          overflow="hidden"
          sx={{ border: '1px solid', borderColor: 'grey.200', bgcolor: 'background.paper' }}
        >
          {!image && (
            <IconWrapper
              icon="photo"
              sx={{ svg: { width: 40, height: 40, mt: -1, stroke: 'grey.300', color: 'grey.300' } }}
            />
          )}

          {image && (
            <Box width={100} height={100} sx={{ img: { width: 1, height: 1 } }}>
              <img src={image} alt="company" />
            </Box>
          )}
        </Stack>
      </Box>
    </>
  );
};
